const BalloonCell = ({ value: balloon }) => {
  if (balloon === undefined || balloon === null) return "—";

  return balloon ? "Yes" : "No";
};

export default BalloonCell;
